import {paramsToUrlData} from "@/utils/url-data-params";
import {DEFAULT_SORT} from 'src/models/recipe/list/sort-config';
import {DEFAULT_PAGE_SIZE} from 'src/models/recipe/list/pagination-config';

// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  RECIPE: '/recipe',
  USER: '/user',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    token: {
      login: `${ROOTS.AUTH}/token/login`,
      loginWithReturnTo: (returnTo) => `${ROOTS.AUTH}/token/login?returnTo=${returnTo}`,
      register: `${ROOTS.AUTH}/token/register`,
    },
  },
  recipe: {
    add: `${ROOTS.RECIPE}/add`,
    browse: `${ROOTS.RECIPE}/browse`,
    browseWithParams: (params) => `${ROOTS.RECIPE}/browse/${paramsToUrlData(params)}`,
    browseWithFilters: (sortBy, filters, pageSize, page) => {
      const preparedParams = {};
      if (sortBy && sortBy !== DEFAULT_SORT) preparedParams.sortBy = sortBy;
      if (pageSize && pageSize !== DEFAULT_PAGE_SIZE) preparedParams.pageSize = pageSize;
      if (page && page !== 1) preparedParams.page = page;
      if (filters.hasFilterFields()) Object.assign(preparedParams, filters.getFilterFields());
      if (Object.keys(preparedParams).length > 0) return `${ROOTS.RECIPE}/browse/${paramsToUrlData(preparedParams)}`;
      return `${ROOTS.RECIPE}/browse`;
    },
    details: (id) => `${ROOTS.RECIPE}/details/${id}`,
    preview: (id) => `${ROOTS.RECIPE}/preview/${id}`,
    edit: (id) => `${ROOTS.RECIPE}/edit/${id}`
  },
  user: {
    account: `${ROOTS.USER}/account`,
    profile: (id) => `${ROOTS.USER}/profile/${id}`,
  },
  homepage: '/'
};
